import {
  TRIPS_ERROR_PATH,
  PageRouteContainer,
} from "@b2bportal/core-utilities";
import {
  useValidateSelfServeHotelCancelPageRoute,
  useSelfServeHotelCancelPageContainer,
} from "./hooks";
import { SelfServeHotelCancelPageView } from "./SelfServeHotelCancel.view";

export const SelfServeHotelCancelPageRoute = () => {
  return (
    <PageRouteContainer
      route={{
        useValidateRouteProps: useValidateSelfServeHotelCancelPageRoute,
        errorRedirectPath: TRIPS_ERROR_PATH,
      }}
      container={{
        useDeriveViewProps: useSelfServeHotelCancelPageContainer,
        Component: SelfServeHotelCancelPageView,
      }}
    />
  );
};
